import ModalStore from "@src/stores/Component/ModalStore";

class ProfileReviewsDialogStore extends ModalStore {
	constructor(rootStore, staticContext) {
		super({
			rootStore,
			staticContext,
		});
	}

	get show() {
		return super.show;
	}

	onClose(clearData) {
		super.onClose(clearData);
	}

	absoluteUrl(url) {
		try {
			const _ = new URL(url);
			return url;
		} catch (e) {
			if (!/https?/.test(url)) {
				return `https://${url}`;
			}
			return url;
		}
	}
}

export default ProfileReviewsDialogStore;
